import request from '../../axios';

export interface IPostBrandStoreOrderPayload {
  advertisement?: string;
  quantity?: string;
}

const postBrandStoreOrder = async (payload: IPostBrandStoreOrderPayload) => {
  await request.post(`/api/v2/order/brand-store-request`, payload);
};

export default postBrandStoreOrder;
